<script setup lang="ts">
  import { computed } from 'vue'
  import { useModalStack } from '@gat-ship/vue-components'
  import AccessRolesModalProvider from './AccessRolesModalProvider.vue'
  import AccessRoleDetailModalProvider from './AccessRoleDetailModalProvider.vue'
  import AccessRoleDetailModal from '../modals/AccessRoleDetailModal.vue'

  // Open-state and the role id come from this modal's entry in the central
  // ordered stack (the `?modals=` codec owns the URL). The role permissions
  // view is a single section, so there is no section param.
  const KIND = 'access-role'
  const stack = useModalStack()
  const entry = computed(() =>
    stack.entries.value.find((item) => item.kind === KIND)
  )

  const open = computed({
    get: () => entry.value != null,
    set: (value) => {
      if (!value) stack.close(KIND)
    }
  })
  const accessRoleId = computed(() => entry.value?.params.id)

  // Switch to another role picked from the sidebar select.
  function handleSelect(roleId: string) {
    if (entry.value) stack.update(KIND, { id: roleId })
  }
</script>

<template>
  <!-- The collection backs the sidebar role switcher + add; the detail provider
       holds the single-role datasource and the name/delete action modals. Both
       fetch lazily (the modal drives the detail fetch on open / id change), so
       mounting this globally at bootstrap does no eager work. -->
  <AccessRolesModalProvider>
    <AccessRoleDetailModalProvider
      :role-id="accessRoleId ?? ''"
      :fetch-on-mount="false"
    >
      <AccessRoleDetailModal
        v-model:open="open"
        :access-role-id="accessRoleId"
        @select="handleSelect"
      />
    </AccessRoleDetailModalProvider>
  </AccessRolesModalProvider>
</template>
